<template lang="pug">
  div
    b-form-row.align-items-center.mb-3
      // SELECTION COUNT
      b-col
        .text-secondary Usuarios seleccionados: {{selectedUsers.length}}
      // SEARCH INPUT
      b-col.mb-2.mb-md-0(md="5")
        b-input-group#search-input(size="sm")
          b-form-input(placeholder="Buscar usuario", v-model="search", debounce="1000" type="search", @update="searchUsers")
          b-input-group-append
            b-input-group-text
              search-icon.icon-md
      // FILTER
      b-dropdown(no-caret,
        variant='primary',
        size="sm"
        :menu-class='["filters-dropdown"]')
        template(#button-content)
          filter-icon.icon-sm
        b-dropdown-header Estatus del bot
        b-dropdown-form
          b-form-checkbox-group(stacked, v-model="filterStatus", @change="searchUsers")
            b-form-checkbox(value="active" ) Activo
            b-form-checkbox(value="inactive" ) Inactivo
        b-dropdown-header Usuario suscrito
        b-dropdown-form
          b-form-checkbox(switch, v-model="subscribed", @change="searchUsers") {{subscribed ? 'Si' : 'No'}}
        b-dropdown-header Usuario bloqueado
        b-dropdown-form
          b-form-checkbox(switch, v-model="banned", @change="searchUsers") {{banned ? 'Si' : 'No'}}
      // SEND BUTTON
      b-col(cols="auto")
        .d-flex
          b-button.mr-2(variant="an", size="sm", @click="sendBroadcast", :disabled="sendingBroadcast")
            .d-flex.align-items-center.justify-content-center
              b-spinner(small, v-if="sendingBroadcast")
              //send-icon.icon-sm(v-else)
              span(v-else) Enviar
          b-button(variant="outline-an", size="sm", :disabled="sendingBroadcast", @click="sendModal = true") Enviar a todos
    b-card.mb-2(no-body)
      // TABLE
      b-table.mb-0(ref="usersTable", :fields="fields", :items="users", hover, small, responsive, show-empty, :busy="loading", selectable, sticky-header, head-variant="white", thead-tr-class="bb-1", selected-variant="primary", @row-selected="onRowSelected", @row-clicked="prevSelect")
        template(#empty)
          .text-secondary.text-center.my-3 {{search ? 'No hay coincidencias con la búsqueda' : 'No hay usuarios para mostrar'}}
        // HEADERS ROWS
        template(#head(index)="{ label }")
          b-form-checkbox(:indeterminate="indeterminate", @change="toggleAllSelected", :checked="allChecked", :disabled="!users.length")
        template(#table-busy)
          .text-center.my-3
            b-spinner(variant="primary")
        // TABLE ROW
        template(#cell(index)="{ index, item, rowSelected }")
          b-spinner(v-if="updatingUser === item.user_id", variant="primary", small )
          b-form-checkbox(v-else, :checked="rowSelected", @change="toggleSelected($event, index, item)", :disabled="!item.is_subscribed || item.banned")
        template(#cell(first_name)="{ item }")
          .d-flex.align-items-center
            b-avatar.mr-2(size="30", :src="item.profile_pic" )
            span(v-if="item.first_name || item.last_name") {{ item.first_name }} {{ item.last_name }}
            span(v-else-if="item.external_id" ) {{item.external_id}}
            span.text-secondary(v-else) N/D
        template(#cell(bot_enabled)="{ value }")
          b-badge(pill, :variant="value ? 'soft-primary' : 'soft-secondary'")
            .d-flex.align-items-center
              v-icon.mr-1(name="circle", style="width: 7px; height: 7px" )
              .text-primary(v-if="value") Bot activo
              .text-dark(v-else) Bot inactivo
        template(#cell(is_subscribed)="{ item, value:isSubscribed }")
          b-form-checkbox(switch, size="sm", :checked="isSubscribed", @change="updateUser(item, { is_subscribed: $event })") {{ isSubscribed ? 'Sí' : 'No' }}
        template(#cell(banned)="{ item, value:banned }")
          b-form-checkbox(switch, size="sm", :checked="banned", @change="updateUser(item, { banned: $event })") {{ banned ? 'Sí' : 'No' }}
    Pagination(:current-page="paginationCurrentPage", :has-next-page="v_paginationHasNextPage", :total-pages="v_paginationTotalPages", :loading="loading", @click="paginationPageChanged($event, 'getUsers')")
    b-modal( v-model="sendModal", hide-footer, centered, header-class="b-0 pb-0", body-class="px-5 pb-5" )
      b-row.justify-content-center.text-center
        b-col(cols="12")
          p Enviar mensaje a {{allUsers}} usuarios
        b-col(cols="9")
          b-button(variant="an", block, @click="sendingBroadcastAllUsers")
            .d-flex.align-items-center.justify-content-center
              send-icon.icon-sm
              span.ml-1 Enviar
</template>

<script>
import Pagination from "@/components/Pagination"
import { createNamespacedHelpers, mapActions } from 'vuex'
//const userController = createNamespacedHelpers('user')

export default {
  name: "CampaignsUsers",
  data () {
    return {
      loading: false,
      sendModal: false,
      updatingUser: null,
      allUsers: 0,
      search: '',
      users: [],
      selectedUsers: [],
      fields: [
        'index',
        { key: 'first_name', label: 'Nombre' },
        { key: 'bot_enabled', label: 'Estatus' },
        { key: 'is_subscribed',  label: 'Suscrito' },
        { key: 'banned',  label: 'Bloqueado' }
      ],
      filterStatus: ['active', 'inactive'],
      subscribed: true,
      banned: false
    }
  },
  props: {
    sendingBroadcast: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: ''
    },
    modelId: {
      type: Number,
      default: 0
    },
  },
  computed: {
    /*...userController.mapState({
      users: state => state.users
    }),*/
    indeterminate () {
      return !!(this.selectedUsers.length && this.selectedUsers.length < this.users.length)
    },
    allChecked () {
      return this.users.length === this.selectedUsers.length
    },
  },
  methods: {
    ...mapActions([
      'user/all',
      'user/search',
      'user/update'
    ]),
    getUsers () {
      this.loading = true

      let botEnabled = null
      if(this.filterStatus.length === 1) {
        console.log(this.filterStatus.includes('active'))
        botEnabled = this.filterStatus.includes('active') ? 1 : 0
      }

      const params = {
        account_id: this.$route.params.account_id,
        model_id: this.modelId,
        text: this.search,
        platform: this.platform,
        subscribed: this.subscribed ? 1 : 0,
        banned: this.banned ? 1 : 0,
        botEnabled,
        ...this.paginationParamsObject
      }

      const action = this.search ? 'search' : 'all'

      this[`user/${action}`]({
        account_id: this.$route.params.account_id,
        params,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          this.parsePaginationDataFromResponse(res)
          this.addSelectedUsers(res.resource)
          this.allUsers = res.total
        }
      })
    },
    addSelectedUsers (data) {
      const { selectedUsers } = this
      const aux = selectedUsers.concat(data)
      this.users = aux.filter((elem, index, self) => {
        return index === self.findIndex((e) => e.user_id === elem.user_id)
      })
      this.$nextTick(() => {
        for (let i = 0; i < selectedUsers.length; i++) {
          this.toggleSelected(true, i, selectedUsers[i])
        }
      })
    },
    searchUsers () {
      this.resetPaginationData()
      this.getUsers()
    },
    updateUser ({ user_id }, data) {
      this.updatingUser = user_id
      this['user/update']({
        user_id,
        ...data,
        callback: res => {
          const userIndex = this.users.findIndex(user => user.user_id === res.resource.user_id)

          if (userIndex !== -1) {
            this.users[userIndex].is_subscribed = res.resource.is_subscribed
            this.users[userIndex].banned = res.resource.banned
          }

          this.updatingUser = null

          res.error ? this.$message.error(res.error) : this.$message.success('Usuario actualizado')
        }
      })
    },
    sendingBroadcastAllUsers () {
      this.$emit('click')
      this.sendModal = false
    },
    sendBroadcast () {
      if(!this.selectedUsers.length) return this.$message.warning('Selecciona usuarios')
      this.$emit('click', this.selectedUsers.map(el => el.user_id))
    },
    toggleAllSelected (checked) {
      if(checked) {
        for (const [index, user] of this.users.entries()) {
          if(user.is_subscribed && !user.banned) {
            this.$refs.usersTable.selectRow(index)
            this.selectedUsers.push(user)
          }
        }
      } else {
        this.$refs.usersTable.clearSelected()
        this.selectedUsers = []
      }
    },
    toggleSelected (checked, index, item) {
      if(checked) {
        this.selectedUsers.push(item)
        this.$refs.usersTable.selectRow(index)
      } else {
        const userIndex = this.selectedUsers.findIndex(el => el.user_id === item.user_id)
        if(userIndex >= 0) {
          this.selectedUsers.splice(userIndex, 1)
          this.$refs.usersTable.unselectRow(index)
        }
      }
    },
    onRowSelected(items) {
      this.selectedUsers = items.filter(el => el.is_subscribed && !el.banned)
    },
    prevSelect (item, index) {
      if(!item.is_subscribed || item.banned) {
        this.$nextTick(() => {
          this.$refs.usersTable.unselectRow(index)
        })
      }
    },
  },
  mounted() {
    this.setPaginationLimit(50)
    this.getUsers()
  },
  watch: {
    modelId () {
      this.searchUsers()
    }
  },
  components: {Pagination}
}
</script>

<style  lang="scss">
  .table .thead-white th {
    color: black;
    background-color: white;
    //border-color: white;
  }
  .table-primary > td{
    background-color: #EFF0FF;
  }
</style>